// Caches an "empty result" marker per-customer to skip the expensive
// at_risk_payments fetch for 24h. Non-empty responses are never cached.

const KEY_PREFIX = 'og-banners:at-risk-payment:';
const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

type CacheEntry = { ts: number };

// True if we recently checked at-risk payments for this customer and got an
// empty result. Failures (missing, expired, corrupt, storage error) return false.
export function hasRecentPaymentsCheck(sigField: string): boolean {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + sigField);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as CacheEntry;
    if (typeof parsed?.ts !== 'number') return false;
    const age = Date.now() - parsed.ts;
    // age >= 0 guards future timestamps from a clock that's been rolled back
    return age >= 0 && age < TTL_MS;
  } catch {
    return false;
  }
}

// Records an empty at_risk_payments result so we can skip the next fetch.
export function markEmptyResult(sigField: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + sigField, JSON.stringify({ ts: Date.now() }));
  } catch {
    // localStorage may be unavailable (e.g. Safari private mode); ignore.
  }
}

// Removes any cached empty marker
export function clearEmptyResult(sigField: string): void {
  try {
    localStorage.removeItem(KEY_PREFIX + sigField);
  } catch {
    // localStorage may be unavailable; ignore.
  }
}
